export default __webpack_public_path__ + "static/media/Miter saw Makita.d447e81b.png";